import NProgress from 'nprogress'
import { Message } from 'element-ui'
import 'nprogress/nprogress.css'
import router from './router'
import store from './store'
import { routePermissionChecking } from './utils/routeBasePermissionCheck'
import hideLoader from './utils/initialLoaderHandler'

NProgress.configure({ showSpinner: false })

const whitelistViews = ['/login']

const redirectIfRouteAccessable = (to, next) => {
  const accessibleRoutes = store.getters['user/accessibleRoutes']
  const hasAccess = routePermissionChecking(accessibleRoutes, to)

  if (hasAccess) {
    return next()
  }

  // No access to this route, abort. Set replace to true to prevent leaving history record.
  return next({ path: '/404', replace: true })
}

router.beforeEach((to, from, next) => {
  // Show progress bar if not on initial page load
  if (from.name) {
    NProgress.start()
  }

  // Logged in
  if (store.getters['user/isLoggedIn']) {
    /**
     * Prevent access to login page if logged in.
     */
    if (to.path === '/login') {
      return next('/')
    }

    /**
     * Get user info every time the user refreshes the page to make sure the user still logged in.
     * Logout user if failed.
     * Only do once per browser refresh
     */
    const needsLoadUserInfo = !store.getters['user/loadedUserInfoOnce']
    if (needsLoadUserInfo) {
      return Promise.all([
        store.dispatch('user/getUserInfo'),
      ]).then(() => {
        redirectIfRouteAccessable(to, next)
      }).catch(() => {
        // Fall back logout
        store.dispatch('user/logout').then(() => {
          Message.error('Verification error, please login again.')
          return next('/login')
        })
      })
    }

    return redirectIfRouteAccessable(to, next)
  }

  // Not Login
  if (whitelistViews.indexOf(to.path) !== -1) {
    return next()
  }

  return next('/login')
})

router.afterEach(() => {
  NProgress.done()
  hideLoader()
})

router.onError((error) => {
  Message.error(error.message)
  NProgress.done()
  hideLoader()
})
